import { render, staticRenderFns } from "./dispensemedicine.vue?vue&type=template&id=7f32073e&scoped=true"
import script from "./dispensemedicine.vue?vue&type=script&lang=js"
export * from "./dispensemedicine.vue?vue&type=script&lang=js"
import style0 from "./dispensemedicine.vue?vue&type=style&index=0&id=7f32073e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f32073e",
  null
  
)

export default component.exports